import React, {Component, Fragment} from 'react'
import { Link, Redirect } from 'react-router-dom';
import { TableHeaderColumn } from "react-bootstrap-table";
import {RenderMoneda, RenderDateTime} from "../../../Utils/renderField/renderTableField";
import {Monedas, getsimbolo} from "../../../../../utility/constants";
import {withRouter} from 'react-router';
import Grid from '../../../Utils/Grid/index';
import { customStandardActions } from "../../../Utils/Grid/StandardActions";
import ImageVer from '../../../../../../assets/img/icons/Ver.png';
// import getsimbolo from '../../../../../utility/constants.js'
// /home/yeicob/Documentos/ayg/frontend/src/js/utility/constants.js
import ToolbarCaja from '../../../Utils/Toolbar/ToolbarCaja';
import {customStandardActions2} from '../../../Utils/Grid/StandardActions';
import renderFieldCheck from '../../../Utils/renderField'
import Swal from 'sweetalert2';


export default class EstadoPeriodo extends Component{

    handleCheckRevisionGasto = (row) => {
        const params = {}
        params.id = row ? row.id : null;
        params.check = !row.check

        Swal.fire({
            title: '¿Desea cambiar el estado del gasto?',
            //text: '¡No podrá revertir esta acción!',
            type: 'question',
            showCancelButton: true,
            confirmButtonText: '¡Aceptar!',
            cancelButtonText: 'No, cancelar',
            reverseButtons: true
        }).then((result) => {
            if(result.value){
                this.props.checkRevisionGasto_EP(params, this.props.estadoPeriodoId)
            }
        })
    }

    render(){
        let {
            data,
            permisos,
            loader,
            dateStartModal,
            dateEndModal,
            setDateStartModal,
            setDateEndModal,
            valorMovimientoModal,
            changeMovimientoModal
        } = this.props
        const T_GASTO_GENERAL = 8;
        const total_debe = data ? data.reduce((acc, item) => acc + parseFloat(item.debe), 0) : 0;
        const total_haber = data ? data.reduce((acc, item) => acc + parseFloat(item.haber), 0) : 0;

        return(
            <div>
                <div className="py-md-3 px-md-3 p-0" style={{border:"1px solid #E8E8E8", }}>
                    <ToolbarCaja
                        buscar={this.props.searchChangeModal}//
                        buscador={this.props.searchModal}//
                        placeholder={"Buscar por Descripcion"}
                        dateStart={dateStartModal}//
                        dateEnd={dateEndModal}//
                        setDateStart={setDateStartModal}//
                        setDateEnd={setDateEndModal}//
                        valorMovimiento={valorMovimientoModal}//
                        changeMovimiento={changeMovimientoModal}//
                        />
               </div>

                <div className="py-md-3 px-md-3 mt-2 mb-2" style={{border:"1px solid #E8E8E8", }}>
                    <div className="col-12 row m-0 p-0">
                        <div className="col-md-6 my-3 d-flex justify-content-center">
                            <div className="col-md-6">
                                <h5>Total Debe:</h5>
                                <h3 className="t-mostaza text-left text-nowrap">
                                    <RenderMoneda monto={total_debe} simbolo={'Q. '} />
                                </h3>
                            </div>
                        </div>
                        <div className="col-md-6 my-3 d-flex justify-content-center">
                            <div className="col-md-6">
                                <h5>Total Haber:</h5>
                                <h3 className="t-mostaza text-left text-nowrap">
                                    <RenderMoneda monto={total_haber} simbolo={'Q. '} />
                                </h3>
                            </div>
                        </div>
                    </div>
               </div>

                <Grid hover striped data={{count:10, results: data}}  loading={loader}  pagination={false}>
                <TableHeaderColumn
                        dataField="liquidacion"
                        dataAlign="center"
                        dataSort
                        width="5%"
                        dataFormat={(cell, row) => {
                            if (cell && !cell.id) return;

                            return customStandardActions(cell, {
                                adicional: (c, r) => {
                                    return <Link to={`/caja/${row.cuenta}/liquidacion/${cell.id}`} >
                                    <img className="action-img-ver" title="ver" src={ImageVer} alt="ver" />
                                </Link>
                                }
                            });
                        }}
                    >
                    </TableHeaderColumn>

                    {permisos.gastos && permisos.revisar_gastos && (
                        <TableHeaderColumn
                            dataField="id"
                            dataAlign="center"
                            dataSort
                            width="5%"
                            dataFormat={(cell, row) =>{
                                if (row.transaccion.tipo_transaccion != T_GASTO_GENERAL) return ;

                                if (row && row.id) {
                                    return customStandardActions2(cell, row, {
                                        adicional: (c, r) => {
                                            return <label className={`mb-0 d-flex py-1 px-0 px-sm-1 flex-row algin-items-center`}>
                                                <div className="flex-1 px-0 mt-1 d-flex justify-content-center centrar-check">
                                                    <input
                                                        type="checkbox"
                                                        component={renderFieldCheck}
                                                        checked={row.transaccion.check}
                                                        onChange={() => {this.handleCheckRevisionGasto(row.transaccion), this.forceUpdate()}}
                                                    />
                                                </div>
                                            </label>
                                        }
                                    })
                                }
                            }}
                        >
                            REVISIÓN
                        </TableHeaderColumn>
                    )}

                    <TableHeaderColumn
                        dataField="creado"
                        dataSort
                        width="15%"
                        dataFormat = {
                            (cell,row)=>(
                                <RenderDateTime fecha={cell}></RenderDateTime>
                            )
                        }
                    >
                        FECHA ACEPTACIÓN
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="fecha"
                        dataSort
                        /*
                        dataFormat = {
                            (cell,row)=>(
                                <RenderDateTime fecha={cell}></RenderDateTime>
                            )
                        }
                        */
                       dataFormat={(cell, row) =>{
                            if (row.liquidacion && row.liquidacion.id) return <RenderDateTime fecha={row.liquidacion.fecha}></RenderDateTime>

                            return <RenderDateTime fecha={cell}></RenderDateTime>
                        }}
                    >
                        FECHA
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        isKey
                        dataField="transaccion"
                        dataSort
                        dataFormat={
                            (cell,row)=> cell?
                            <div>
                                <span className="font-weight-bold">Tipo de movimiento: </span>
                                {row.transaccion.nombre_tipo_transaccion}
                                <br />
                                {
                                    row.transaccion.nombre_proveedor && (
                                        <div>
                                            <span className="font-weight-bold">Proveedor: </span>
                                            {row.transaccion.nombre_proveedor}
                                            <br />
                                        </div>
                                    )
                                }
                                <span className="font-weight-bold">Descripción: </span>
                                {cell.descripcion}
                                {
                                        row.emitido_por &&(
                                            <Fragment>
                                                <span className="font-weight-bold">Enviada por: </span>
                                                <span style={{ color: "black" }} >{row.emitido_por}</span>
                                                <br />
                                            </Fragment>
                                        )
                                    }
                                    {
                                        row.aceptado_por &&(
                                            <Fragment>
                                                <span className="font-weight-bold">Aceptada por: </span>
                                                <span style={{ color: "black" }} >{row.aceptado_por}</span>
                                                <br />
                                            </Fragment>
                                        )
                                    }
                            </div>
                            :"-------"
                        }
                    >
                        DESCRIPCIÓN
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="es_ingreso"
                        dataSort
                        dataFormat={
                            (cell,row)=>(
                                cell ? 'Ingreso':'Egreso'
                            )
                        }
                    >
                        MOVIMIENTO
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="debe"
                        dataSort
                        dataFormat={
                            (cell,row)=>(
                                <RenderMoneda monto={cell} simbolo={getsimbolo(row.moneda)} />
                            )
                        }
                    >
                        DEBE
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="haber"
                        dataSort
                        dataFormat={
                            (cell,row)=>(
                                <RenderMoneda monto={cell} simbolo={getsimbolo(row.moneda)} />
                            )
                        }
                    >
                        HABER
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="saldo"
                        dataSort
                        dataFormat={
                            (cell,row)=>(
                                <RenderMoneda monto={cell} simbolo={getsimbolo(row.moneda)} />
                            )
                        }
                    >
                        SALDO
                    </TableHeaderColumn>
                </Grid>
                <br/>
            </div>
        )
    }
}
